export const LS_KEY_LAST_CHECK = "version_last_check";
export const LS_KEY_VERSION = "version";
